import qwest from 'qwest';
import Branch from 'models/branch.jsx';
import BranchSummary from 'models/branchSummary.jsx';
import session from 'services/sessionService.jsx';

let branchApi = {
  getBranch(id) {
    return new Promise((resolve, reject) => {
      let branch = session.getBranch(id);

      if (branch) {
        resolve(branch);
      } else {
        qwest.get(`/Branch?id=${id}`)
          .then((xhr, response) => {
            if (response.success) {
              branch = Branch.fromApiFormat(response.data);
              session.setBranch(branch);
              resolve(branch);
            } else {
              reject(response);
            }
          })
          .catch(err => reject(err));
      }
    });
  },

  getMyBranches() {
    return new Promise((resolve, reject) => {
      let branches = session.getMyBranches();

      if (branches.length > 0) {
        resolve(branches);
      } else {
        qwest.get('/Branch/Mine')
          .then((xhr, response) => {
            if (response.success) {
              branches = response.data.map(x => BranchSummary.fromApiFormat(x));
              session.setMyBranches(branches);
              resolve(branches);
            } else {
              reject(response);
            }
          })
          .catch(err => reject(err));
      }
    });
  },

  getFullBranches() {
    return new Promise((resolve, reject) => {
      qwest.get('/Branch/EditableList')
        .then((xhr, response) => {
          if (response.success) {
            let branches = response.data.map(x => Branch.fromApiFormat(x));

            resolve(branches);
          } else {
            reject(response);
          }
        })
        .catch(err => reject(err));
    });
  },

  saveBranch(branch, b64data) {
    let apiBranch = branch.toApiFormat();

    if (b64data) {
      return qwest.post(`/Branch/WithLogo/${branch.id}`, {
        branch: apiBranch,
        logo: b64data,
      })
      .then((xhr, response) => {
        if (response.success) {
          let updatedBranch = Branch.fromApiFormat(response.data);

          session.setBranch(updatedBranch);
          return updatedBranch;
        } else {
          throw new Error('Could not save branch.');
        }
      });
    }

    return qwest.post('/Branch', branch.toApiFormat())
      .then((xhr, response) => {
        if (response.success) {
          let updatedBranch = Branch.fromApiFormat(response.data);

          session.setBranch(updatedBranch);
          return updatedBranch;
        } else {
          throw new Error('Could not save branch.');
        }
      });
  },

  validateReplyEmailDuplicate(branch) {
    return new Promise((resolve, reject) => {
      qwest.post('/Branch/ValidateReplyEmailDuplicate', branch.toApiFormat()).then((xhr, response) => {
        if (response.success) {
          resolve(response.data);
        } else {
          reject(response);
        }
      });
    });
  },
};

export default branchApi;
